import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-multi-lang'
import {AttachMoney} from '@mui/icons-material'
import MyAlert from '../../components/alert-system/alert'
import API, { company } from '../../services/api/api';
// Stylesheet
import './Dashboard.css'

// Cookies
import { useCookies } from 'react-cookie'

// Components
import { SideNav, SideNav_v1, TopNav } from '../../components/Nav/Nav'

import { havePermission } from '../../services/hoc/permissions'

import SettingContext, { iAlert } from '../../services/context/setting-contentxt/setting-context'
import {useContext} from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { isValidJSON } from '../../services/hoc/helpers';
import { AxiosError, AxiosResponse } from 'axios';

import { Confirm } from '../../components/Alerts/ALerts_new';
import DeleteModalContext from '../../services/context/delete-modal/delete-modal-context';
import { iDeleteModal } from '../../services/context/delete-modal/delete-modal-provider';


export default (props: any) => {
const {alert,setAlert}=useContext(SettingContext)
const {openDeleteModal,setOpenDeleteModal} =useContext(DeleteModalContext)
    const t = useTranslation()
    const {isPc}=useContext(SettingContext)
    
    const [cookies, setCookie, removeCookie] = useCookies();
    const location=useLocation()

    // API
    const ENDPOINTS = new API(cookies?.userinfo.accessToken,removeCookie)
    const navList = [
        {
            icon: "icon-overview",
            name: t("basics"),
            show:true,
            childs: [
                {
                    icon: "icon-dashboard",
                    name: t("dashboard"),
                    link: "/",
                    show: havePermission("View Glass ")
                },
                {
                    icon: "icon-product",
                    name: t("materials"),
                    link: "/materials",
                    show: havePermission("View Glass ")
                },
                {
                    icon: "icon-hammer",
                    name: t("services"),
                    link: "/services",
                    show: havePermission("View Glass Work")
                },
                {
                    icon: "icon-tasks",
                    name: t("pricing"),
                    link: "/pricing",
                    show: havePermission("View Pricing")
                },
                  {
                    icon: "icon-transactions",
                    name: t("expenses_type"),
                    link: "/expenses_type",
                    show: havePermission("View Expenses Type")
                },
            ]
        },
        {
            icon: <AttachMoney />,
            name: t("sells"),
            show: true,
            childs: [
                {
                    icon: "icon-users",
                    name: t("clients"),
                    link: "/clients",
                    show: havePermission("View Client"),
                },
                // {
                //     icon: "icon-customer",
                //     name: t("suppliers"),
                //     link: "/suppliers",
                //     show: havePermission("View Suppliers"),
                // }   {
                 {   icon: "icon-orders",
                    name: t("orders"),
                    link: "/orders",
                    show: havePermission("View Order"),
                },
                {
                    icon: "icon-bill",
                    name: t("bills"),
                    link: "/bills",
                    show: havePermission("View Bill"),
                },
                {
                    icon: "icon-receipt",
                    name: t("receipt"),
                    link: "/receipt-vouchers",
                    show: havePermission("View Receipt Voucher"),
                }
               
            ]
        },
        {
            icon: "icon-orders",
            name: t("purchases"),
            show:true,
            childs: [
                
                 {
                     icon: "icon-customer",
                     name: t("suppliers"),
                     link: "/suppliers",
                     show: havePermission("View Supplier"),
                 } ,
                 {
                    icon: "icon-invoice",
                    name: t("purchse_requests"),
                    link: "/purchase-orders",
                    show: havePermission("View Purchase Order"),
                 },
                 {
                    icon: "icon-invoice",
                    name: t("purchase_bills"),
                    link: "/purchase-bills",
                    show: havePermission("View Purchase Bill"),
                 },
                 {
                    icon: "icon-voucher",
                    name: t("payment"),
                    link: "/payment-vouchers",
                    show: havePermission("View Payment Voucher"),
                }
                
                // {
                //     icon: "icon-invoice",
                //     name: t("receipt_orders"),
                //     link: "/receipt-orders",
                //     show: havePermission("View Receipt Orders"),
                // },
            ]
        },
         {
             icon: "icon-receipt",
             name: t("reports"),
             show: true,
             childs: [
                //  {
                //      icon: "icon-receipt",
                //      name: t("dashboard"),
                //      link: "/reports",
                //      show: havePermission("View Receipt Vouchers"),
                //  },
                 {
                     icon: "icon-voucher",
                     name: t("inventory_reports"),
                     link: "/reports",
                     show: havePermission("View Payment Voucher"),
                 },
                //  {
                //      icon: "icon-voucher",
                //      name: t("statistical_reports"),
                //      link: "/reports",
                //      show: havePermission("View Payment Vouchers"),
                //  },
               
                
         ]
        },
        // {
        //     icon: "icon-receipt",
        //     name: t("sells"),
        //     show: havePermission("View Receipt Vouchers") || havePermission("View Payment Vouchers"),
        //     childs: [
        //         {
        //             icon: "icon-receipt",
        //             name: t("receipt"),
        //             link: "/receipt-vouchers",
        //             show: havePermission("View Receipt Vouchers"),
        //         },
               
        //     ]
        // },
        {
            icon: "icon-gear",
            name: t("configurations"),
            show: true
            ,
            childs: [
                {
                    icon: "icon-user",
                    name: t("employees"),
                    link: "/employees",
                    show: havePermission("View Employee"),
                },
                {
                    icon: "icon-lock",
                    name: t("roles"),
                    link: "/roles",
                    show: havePermission("View Role"),
                },
                {
                    icon: "icon-user",
                    name: t("users"),
                    link: "/users",
                    show: havePermission("View User"),
                },
                {
                    icon:"icon-info",
                    name:t("company_info"),
                    link:"/company-info/1",
                    show:havePermission('View Company')
                }
            ]
        }
    ]
    const fetchCompanyDatad = () => {
        ENDPOINTS.company()
          .index({page:1,page_size:1000})
          .then((response: any) => {
            
            if (response.data.data &&  
                response.data.data.companies&&response.data.data.companies.length>0){

                let company: company = response.data.data.companies[0];
        
                setCookie('company_info', company);
            }
          });
      };
  const fetchPermissions = (id:number) =>{
    ENDPOINTS.roles()
    .showPermissions({id})
    .then((res:any)=>{
       
        if (res.data && res.data.data) {

             sessionStorage.setItem('permissions',JSON.stringify(res.data.data.permissions))
            //setPermissions(res.data.data.permissions)
            window.location.reload()

        }
    })
    .catch ((err:any)=>{
console.log(err)
    })
  }    
  const fetchSorts =()=> {
    ENDPOINTS.other()
    .viewSort({page:1,page_size:100})
    .then((res:AxiosResponse)=>{
        if (res.data  ){
            
            localStorage.setItem("sort",JSON.stringify({sort:res.data.data.view_sort}))
           
        }
    })
    .catch((err:AxiosError)=>{
        
        console.log(err.toJSON())
        
    })
  }
  
const checkCookies=()=>{
   
    if (cookies && !cookies['company_info']  ) {
        fetchCompanyDatad()
    }
    
    // else {
    //  //console.log('removing cookies')
    //  removeCookie('company_info',{path:'/'})
    // }
    
}

 useEffect(()=>{
checkCookies()
 },[])

 useEffect(()=>{
    
    if (!isValidJSON(localStorage.getItem("sort") || "")) {

     fetchSorts()
        
    }

 },[])

useEffect(()=>{
    if (cookies && cookies['userinfo']&& !isValidJSON(sessionStorage.getItem("permissions") || "")) {
   
        fetchPermissions(cookies['userinfo']?.role?.id)
    }
    
},[])


    return (
        <div className="dashboard-page">
           {isPc && <SideNav_v1 list={navList} active={location.pathname.slice(1)}  />}
            <div className="main-side">
                <TopNav navList={navList} />
                   
              
                <div className="content" >
                   <Outlet/>
                </div>
            </div>
            <MyAlert 
            open={alert.openAlert}
            message={alert.alertMessage}
            type={alert.alertType}
            setOpen={()=>setAlert((pre:iAlert)=>({...pre,openAlert:false}))}
            /> 
            {openDeleteModal.open &&
                <Confirm 
              message={openDeleteModal.message}
              onConfirm={() => openDeleteModal.remove()}
              onClose={()=>setOpenDeleteModal((pre:iDeleteModal)=>({...pre,open:false}))}
              drawer_parent={openDeleteModal.drawer_parent}
            />
            }
        </div>
    )
}